import {
  activeMemberships,
  activeNewSkusMemberships
} from "@membership/constants";

// Keep this mapping for any Contentful entries (Promotions, CTAs)
// using old membership SKUs.

export const membershipVariants = {
  [`${activeMemberships["en-GB"].sixtyDayFreeTrialRenewsToMonthlyMembershipId}`]:
    activeMemberships["en-GB"].sixtyDayFreeTrialRenewsToAnnualMembershipId,
  [`${activeNewSkusMemberships["en-GB"].sixtyDayFreeTrialRenewsToMonthlyMembershipId}`]:
    activeNewSkusMemberships["en-GB"]
      .sixtyDayFreeTrialRenewsToAnnualMembershipId,
  [`${activeMemberships["en-US"].sixtyDayFreeTrialRenewsToMonthlyMembershipId}`]:
    activeMemberships["en-US"].sixtyDayFreeTrialRenewsToAnnualMembershipId,
  [`${activeNewSkusMemberships["en-US"].sixtyDayFreeTrialRenewsToMonthlyMembershipId}`]:
    activeNewSkusMemberships["en-US"]
      .sixtyDayFreeTrialRenewsToAnnualMembershipId
};

export const getMembershipVariant = (id: string): string => {
  if (!membershipVariants[id]) {
    return id;
  }
  return membershipVariants[id] || id;
};
